export const JOB_BOARD_TABLES = [
  { key: "jobApplications", label: "Job Board Applications" },
  { key: "jobPosts", label: "Job Board Posts" },
  { key: "featuredListings", label: "Featured Listings" },
  { key: "boostedPosts", label: "Boosted Posts" }
];

export const filterJobBoardRows = (rows = [], query = "") => {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return rows.slice();
  return rows.filter(row =>
    Object.values(row).some(value =>
      value !== null && value !== undefined
        ? String(value)
            .toLowerCase()
            .includes(normalized)
        : false
    )
  );
};
